import { useEffect } from 'react'
import type { JSX } from 'react'

import {
  Badge,
  Button,
  Card,
  Dialog,
  List,
  Heading,
  Strong,
  Text,
  CheckIcon,
  RefreshCwIcon,
  InfoIcon,
} from '@buffer-mono/popcorn'

import styles from '../../InstagramSelectAccountType.module.css'

import useAuthorizationInfo from '../../../../hooks/useAuthorizationInfo/useAuthorizationInfo'
import { InstagramAuthMethod, Service } from '../../../../types'
import type { OnRedirectParams } from '../../../../types'

export function ProfessionalCard({
  onRedirect,
}: {
  onRedirect: (args: OnRedirectParams) => void
}): JSX.Element {
  const { handleGetAuthorizationInfo, url, isAuthorizationInfoLoading } =
    useAuthorizationInfo()

  useEffect(() => {
    handleGetAuthorizationInfo({
      service: Service.instagram,
      authMethod: InstagramAuthMethod.instagramLogin,
      isRefreshingConnection: false,
    })
  }, [handleGetAuthorizationInfo])

  return (
    <Card className={styles.profesionalCard}>
      <Heading className={styles.heading}>
        Professional{' '}
        <Text as="span" size="lg" className={styles.headingSubtext}>
          {' '}
          (Business & Creator)
        </Text>
      </Heading>
      <Badge className={styles.badge} size="small" variant="brand-subtle">
        <RefreshCwIcon size="small" /> Automatic & Notification-based Posting
      </Badge>
      <Text
        size="sm"
        className={styles.badgeMobileText}
        icon={<RefreshCwIcon size="small" />}
      >
        Automatic & Notification-based Posting
      </Text>
      <List>
        <List.Item icon={CheckIcon}>
          <Text>
            <Strong>Automatic posting</Strong> - You schedule and we&apos;ll
            post
          </Text>
        </List.Item>
        <List.Item icon={CheckIcon}>
          <Text>
            <Strong>Notifications</Strong> - We notify you, then you finish in
            app
          </Text>
        </List.Item>
        <List.Item icon={CheckIcon}>
          <Text>
            <Strong>Community</Strong> - Easily reply to comments
          </Text>
        </List.Item>
        <List.Item icon={CheckIcon}>
          <Text>
            <Strong>Sent Post Metrics</Strong> - View past post performance
          </Text>
        </List.Item>
      </List>

      <Button
        onClick={(): void => {
          if (url) {
            onRedirect({
              redirectUrl: url,
              authMethod: InstagramAuthMethod.instagramLogin,
            })
          }
        }}
        disabled={isAuthorizationInfoLoading}
        loading={isAuthorizationInfoLoading}
        size="large"
        variant="primary"
        className={styles.action}
      >
        Connect to Instagram
      </Button>
      <Dialog.Separator className={styles.separator} />
      <Text className={styles.infoTextFooter} icon={<InfoIcon size="small" />}>
        Instagram will prompt you to easily convert to a professional account if
        needed.
      </Text>
    </Card>
  )
}
